import "./progress-bar.scss";

type ProgressBarProps = {
	progress: number;
	ref: React.Ref<HTMLDivElement>;
};

export const ProgressBar = ({ progress, ref }: ProgressBarProps) => {
	return (
		<div className='progress-bar' ref={ref}>
			<div className='progress-bar__wrapper'>
				<div
					className='progress-bar__progress'
					style={{ width: `${progress}%` }}></div>
			</div>
		</div>
	);
};
